import { useLocation, useNavigate } from "react-router-dom";

import { AuthLink } from "./components/AuthLink";
import { SubmitHandler, useForm } from "react-hook-form";
import useAxios from "axios-hooks";

type Inputs = {
  newPassword: string;
};

export default function ForceChangePassword() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const [{ data, loading, error }, login] = useAxios(
    {
      url: "/auth/login/force-change-password",
      method: "POST",
    },
    {
      manual: true,
    }
  );

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      let response = await login({
        data: data,
      });

      if (response.status === 200) {
        navigate("/");
      }
    } catch (error) {}
  };

  return (
    <div className="flex items-center justify-center flex-col h-full gap-4">
      <div className="w-1/2 bg-warning rounded-lg p-2 text-sm text-yellow-900 text-center">
        It appears that your account currently has a temporary password set up.
        To sign in, please create a new password.
      </div>
      <form className="flex flex-col w-1/2" onSubmit={handleSubmit(onSubmit)}>
        <label className="form-control w-full">
          <div className="label">
            <span className="label-text">New Password</span>
          </div>
          <input
            disabled={loading}
            {...register("newPassword", {
              required: true,
            })}
            type="password"
            className="input input-bordered input-sm w-full"
          />
          <div className="label">
            {errors?.newPassword?.type === "required" && (
              <span className="label-text-alt text-error">
                This field is required
              </span>
            )}
          </div>
        </label>
        <div className="pt-2 w-full">
          <button
            className="btn btn-sm w-full btn-primary"
            disabled={loading}
            type="submit"
          >
            Change Password
          </button>
        </div>
        {error && (
          <div className="alert alert-error text-sm mt-6 text-center">
            {error?.response?.data?.message}
            {error?.response?.data?.__type === "UserNotConfirmedException" && (
              <button
                onClick={(e) => {
                  e.preventDefault();
                }}
                className="btn btn-xs ml-auto"
              >
                Resend code
              </button>
            )}
          </div>
        )}
        {loading && (
          <div className="flex items-center justify-center mt-6">
            <div className="loading loading-spinner "></div>
          </div>
        )}
        {state?.confirmed && (
          <div className="alert alert-success text-sm mt-6 text-center">
            {state?.message}
          </div>
        )}
      </form>

      <div className="flex flex-col gap-2 items-center">
        <AuthLink
          label="Login"
          message="Already have an account?"
          path="/auth/login"
        ></AuthLink>
        <AuthLink
          label="Forgot Password"
          message="You forgot your password?"
          path="/auth/forgot-password"
        ></AuthLink>
      </div>
    </div>
  );
}
